import Choices from "choices.js";
import { getElements } from "@oddcamp/js-utils/src/selector";

const defaultOptions = window.CHOICES_OPTIONS || {};
let instances = [];

const init = () => {
  instances = [];
  let selects = getElements(".js--choices");
  if (selects.length) {
    selects.forEach((select) => {
      instances.push({
        element: select,
        html: select.outerHTML,
        choices: new Choices(select, defaultOptions),
      });
    });
  }
};

const destroy = () => {
  instances.forEach((inst) => {
    inst.choices.destroy();
    inst.element.outerHTML = inst.html; // because Choices.destroy() doesn't work as it should (doesn't restore element to it's default form)
  });
};

if (typeof Turbolinks !== "undefined") {
  document.addEventListener("turbolinks:load", init);
  document.addEventListener("turbolinks:before-cache", destroy);
} else {
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", init)
    : init();
}
